import React, { useEffect, useContext, useState } from 'react';
import { ChartContainer, TableHeading } from './CiTradesTable.style';
import { ciTradeTableData } from '../../../../../../api/services';
import { BaseTable, Flexbox } from '@sede-enterprise/shell-ds-react-framework';
import { AppContext } from '../../../../../../Context/AppContext';
import { ICiTradeTableData } from '../../../../../../Types/types';
import DownloadCsvButton from '../../../../../ReUsableComponents/DownloadCsvButton/DownloadCsvButton';
import { NCF_DASHBOARD_QTY_DECIMAL_PLACES } from '../../../../../../api/constants';
import { errorNotifyMessage, isApiResponseEmpty } from '../../../../../Utils/utils';
import { SortingState, getSortedRowModel } from '@tanstack/react-table';
import { notify } from '../../../../../../../CarbonDashboard/components/Toast/notify';

interface CiTradesTableProps {
  setIsCiTradeTableApiResponseEmpty: (isEmpty: boolean) => void;
}

const CiTradesTable: React.FC<CiTradesTableProps> = ({ setIsCiTradeTableApiResponseEmpty }) => {
  const { state: analyticsState, dispatch: analyticsDispatch } =
    useContext(AppContext).ciTradeAndVolume;
  const [sorting, setSorting] = useState<SortingState>([]);
  const mapData: ICiTradeTableData[] = analyticsState.ciTradeTableData;
  const sum = mapData?.reduce((acc, item) => acc + item.QTY, 0)?.toFixed(NCF_DASHBOARD_QTY_DECIMAL_PLACES);
  const tableFormattedData = [...mapData].map((el) => {
    return {
      ...el,
      QTY: Number(el.QTY).toFixed(NCF_DASHBOARD_QTY_DECIMAL_PLACES),
    };
  });

  const columnNames = [
    'CPTY',
    'CPTY_DESC',
    'YEAR',
    'MONTH',
    'QTY',
    'NCF_CATEGORY',
    'DEAL_TYPE_NAME',
    'NCF_SCOPE',
  ];
  const columns = columnNames.map((key) => ({
    header: key.replace(/_/g, ' '),
    accessorKey: key,
  }));


  const tableOptions = {
    state: {
      sorting,
    },
    onSortingChange: setSorting,
    getSortedRowModel: getSortedRowModel()
  };
  const fetchData = async () => {
    try {
      const response = await ciTradeTableData(analyticsState.ciTradeFilteredValues);
      // Use the analyticsDispatch function to call setNcfQuarterwise
      analyticsDispatch({
        type: 'setCiTradeTableData',
        payload: response.data,
      });
      if (analyticsState.ciTradeFilteredValues.region.length !== 0 &&
        analyticsState.ciTradeFilteredValues.commodity.length !== 0) {
        setIsCiTradeTableApiResponseEmpty(isApiResponseEmpty(
          response.data,
          analyticsState.ciTradeFilteredValues.region,
          analyticsState.ciTradeFilteredValues.commodity
        ));
      }
    } catch (error) {
       notify('error', errorNotifyMessage(error));
    }
  };
  useEffect(() => {
    fetchData();
  }, [analyticsDispatch, analyticsState.ciTradeFilteredValues, setIsCiTradeTableApiResponseEmpty]); // Add all dependencies

  return (
    <ChartContainer>
      <Flexbox style={{ width: '100%' }} justifyContent='space-between'>
        <TableHeading>CI Trades Table</TableHeading>
        <Flexbox justifyContent='flex-end' alignItems='center' style={{ flex: 1 }}>
          <DownloadCsvButton data={tableFormattedData} fileName={'CiTrade'} />
        </Flexbox>
      </Flexbox>

      <>
        <BaseTable
          columns={columns}
          data={tableFormattedData}
          size='large'
          data-testid='base-table'
          stickyHeader
          maxHeight={800}
          width={'100%'}
          tableOptions={tableOptions as unknown as Object}
        />
        Total {sum}
      </>
    </ChartContainer>
  );
};

export default CiTradesTable;